module.exports = __webpack_public_path__ + "img/31.3fe2d6aa.jpg";